import classNames from 'classnames';
import { IProvider, EDashboardView } from 'common/interfaces/provider';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';
import moment = require('moment');

// Styles
const s = require('./SalesDashboardLeadOrNoteCard.css');

// Props
interface ISalesDashboardLeadProps extends IAppOnlyStore {
  index: number;
  lead: IProvider;
}

// Component
@inject('store')
@observer
export class SalesDashboardLead extends React.Component<
  ISalesDashboardLeadProps,
  {}
> {
  @computed private get isEvenEntry(): boolean {
    return this.props.index % 2 <= 0;
  }

  @computed private get location(): string {
    const { lead } = this.props;

    let location = '';
    location += lead.plCity || '';
    location += lead.plState ? ', ' + lead.plState : '';
    location += lead.plZipcode ? ' ' + lead.plZipcode : '';

    return location;
  }

  public render() {
    const {
      lead,
      store: {
        leads: { leadsDashboardView },
      },
    } = this.props;

    return (
      <div
        id={this.props.store.lead.generateDashboardLeadCardId(lead.databaseId)}
        onClick={this.handleLeadClick}
        className={classNames(s.card, s.lead, {
          [s.inList]: leadsDashboardView === EDashboardView.List,
          [s.isEven]: this.isEvenEntry,
        })}
      >
        <div className={s.inner}>
          <div
            id={this.props.store.lead.generateDashboardLeadCardNameId(
              lead.databaseId
            )}
            className={s.idContainer}
          >
            <p className={s.id}>
              <span>#</span>
              <strong>{lead.providerId || lead.databaseId}</strong>
            </p>
          </div>

          <a className={s.name}>
            {(lead.dba || lead.legalBusName) && (
              <strong>{lead.dba || lead.legalBusName}</strong>
            )}

            {lead.dba && lead.legalBusName && <span>{lead.legalBusName}</span>}
          </a>

          <ul className={classNames(s.details, s.lastActivity)}>
            {typeof lead.lastCompletedActivity !== 'undefined' &&
              lead.lastCompletedActivity !== null && (
                <li>
                  Last completed activity:{' '}
                  <p>
                    {lead.lastCompletedActivity.activityTypeName +
                      ' on ' +
                      moment(lead.lastCompletedActivity.updatedAt).format(
                        'MMM, Do, YYYY - hh:mm A'
                      )}
                  </p>
                </li>
              )}
          </ul>

          <ul className={classNames(s.details, s.contact)}>
            {this.location && (
              <li>
                {'Location: '}
                <p>{this.location}</p>
              </li>
            )}

            {lead.plPhone && (
              <li>
                {'Phone: '}
                <p>
                  <a
                    onClick={this.handlePhoneNumberClick}
                    href={`tel:+1 ${lead.plPhone.replace(/ /g, '')}`}
                  >
                    {lead.plPhone}
                  </a>
                </p>
              </li>
            )}
          </ul>

          {(typeof lead.lastCompletedActivity === 'undefined' ||
            lead.lastCompletedActivity === null) &&
            !this.location &&
            !lead.plPhone && <br />}
        </div>
      </div>
    );
  }

  private handleLeadClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.store.leads.lastLeadId = this.props.lead.databaseId;
    this.props.store.lead.handleLeadSelect(this.props.lead.databaseId);
  };

  private handlePhoneNumberClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Dashboard/SalesDashboardLead.tsx